import { render, staticRenderFns } from "./SaveConfirmDialog.vue?vue&type=template&id=22ec232a"
import script from "./SaveConfirmDialog.vue?vue&type=script&lang=js"
export * from "./SaveConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports